export enum InquiryStatus {
  Booked = 'booked',
  Canceled = 'canceled',
  Inquiry = 'inquiry'
}
